import React from 'react';
import Countdown from 'react-countdown';
import { connect } from 'unistore/react';

import { AlertMsg } from '../../common';

// import SmallPulse from '../../../Loader/smallPulse';

import { getCoinProperty, getCountryProps } from '@utils/params';
import { getConvRate } from '@utils/storeUtils';

import { moneyFormatter } from '@utils/customLib';

const BorrowTimer = ({ hours, minutes, seconds }) => (
	<b className=" u-text--singleLine">
		{hours > 0 ? `${hours}h : ` : ''}
		{minutes}m {hours > 0 ? '' : `: ${seconds}s`}
	</b>
);

export const getAppropMsg = (
	coinName,
	type,
	expiry,
	margin_taken,
	worth_required,
	worth_current,
	country
) => {
	const { sym, currCode: id, numberFormat } = getCountryProps(country);
	const convRate = getConvRate(0, id);

	switch (type) {
		case 'a': // About to Expire
			return {
				alertType: -1,
				title: 'Reminder:',
				icon: getCoinProperty(coinName, 'coinIcon'),
				text: (
					<>
						Your {coinName} Borrow order (
						{moneyFormatter(
							margin_taken,
							{
								maximumFractionDigits: getCoinProperty(
									coinName,
									'floatPlaces'
								),
							},
							numberFormat
						)}{' '}
						{coinName}) is about to expire in{' '}
						<Countdown
							date={new Date(expiry).getTime() + 19800000}
							key={expiry}
							renderer={BorrowTimer}
						/>
					</>
				),
				links: [
					{
						text: 'Settle Now',
						link: '/margin-trades/',
						type: 0,
					},
				],
			};
		case 'e': // Expired
			return {
				alertType: -1,
				title: 'Reminder:',
				icon: getCoinProperty(coinName, 'coinIcon'),
				text: (
					<>
						Your {coinName} Borrow order (
						{moneyFormatter(
							margin_taken,
							{
								maximumFractionDigits: getCoinProperty(
									coinName,
									'floatPlaces'
								),
							},
							numberFormat
						)}{' '}
						{coinName}) has expired.
					</>
				),
				links: [
					{
						text: 'Settle Now',
						link: '/margin-trades/',
						type: 0,
					},
				],
			};
		case 'f': // Expired
			return {
				alertType: -2,
				title: 'Attention!',
				icon: 'https://bitbns.com/assets/img/appIcons/svg/dispute.svg',
				text: (
					<>
						Your Margin Trade is in Liquidate Zone since your worth
						is below {sym}
						{moneyFormatter(
							worth_required * convRate,
							undefined,
							numberFormat
						)}{' '}
						<br />
						<span className="text-sm text-lightGray">
							Your current worth: {sym}
							{moneyFormatter(
								worth_current * convRate,
								undefined,
								numberFormat
							)}
						</span>
					</>
				),
				links: [
					{
						text: 'See Status',
						link: '/margin-trades/',
						type: 0,
					},
				],
			};

		case 'd': // Expired
			return {
				alertType: -2,
				title: 'Warning!',
				icon: 'https://bitbns.com/assets/img/appIcons/svg/alert.svg',
				text: `Your Margin Trade is in Deposit Zone. Deposit atleast ${sym}${moneyFormatter(
					worth_required - worth_current,
					undefined,
					numberFormat
				)} worth of crypto/fiat currency to prevent liquidation!`,
				links: [
					{
						text: 'See Status',
						link: '/margin-trades/',
						type: 0,
					},
					{
						text: 'Deposit Now',
						link: '/wallets/',
						type: 0,
					},
				],
			};
		default:
			return {};
	}
};

const AlertsRow = ({
	margin_taken,
	worth_required,
	worth_current,
	expiry,
	coinName,
	type,
	country,
	convRates,
}) => (
	<AlertMsg
		{...getAppropMsg(
			coinName,
			type,
			expiry,
			margin_taken,
			worth_required,
			worth_current,
			country,
			convRates
		)}
	/>
);

export default connect('convRates')(AlertsRow);
